module.exports = __webpack_public_path__ + "img/icons B_10.2aa05e60.svg";